import { useGetPartnerQuery } from '@/api/api.slice.tsx';
import { Field } from '@/features/OnBoarding/StepReview/Field.tsx';
import { Card, Loader } from '@arsnovasystems/ars-front-lib';
import SwitchAccountRoundedIcon from '@mui/icons-material/SwitchAccountRounded';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * AccountSide component
 *
 * @returns JSX of the component
 */
export const AccountSide = () => {
  const { t } = useTranslation();

  const { data: me, isLoading } = useGetPartnerQuery();

  if (isLoading || !me) {
    return <Loader />;
  }

  return (
    <Card
      title={t('ik.your.account')}
      subtitle={t('ik.onboarding.lastStep.subHeaderGeneralHint')}
      Avatar={<SwitchAccountRoundedIcon />}
      sx={{
        flex: 1,
      }}
    >
      <Stack sx={{ marginTop: 2, gap: '2px' }}>
        <Field
          label={t('ik.name')}
          value={me.name}
        />
        <Field
          label={t('ik.email')}
          value={me.email}
        />
        <Field
          label={t('ik.last.name')}
          value={me.lastName}
        />
        <Field
          label={t('ik.first.name')}
          value={me.firstName}
        />
        <Field
          label={t('ik.phone.number')}
          value={me.phoneNumber}
        />
        <Field
          label={t('ik.address')}
          value={me.address}
        />
        <Field
          label={t('ik.state')}
          value={me.stateRegion}
        />
        <Field
          label={t('ik.zip.code')}
          value={me.zipCode}
        />
        <Field
          label={t('ik.town')}
          value={me.town}
        />
      </Stack>
    </Card>
  );
};
